<template>
  <div>
    <div>
      <div class="vx-row justify-end mb-4">
        <div class="vx-col">
          <vs-button @click="onClickAdd"> 登録 </vs-button>
        </div>
      </div>
      <v-expansion-panels v-model="openingPanel">
        <v-expansion-panel value="panel1">
          <v-expansion-panel-title class="bg-white border-transparent">
            レポート一覧
            <template v-slot:actions="{ expanded }">
              <VueFeather :type="expanded ? 'chevron-up' : 'chevron-down'" class="feather-icon feather-icon-css-target inline-flex" />
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <data-table
              :column-defs="tableProp.tasks.columnDefs"
              :default-col-def="tableProp.tasks.defaultColDef"
              :row-data="reportTasks"
              :grid-options="tableProp.tasks.gridOptions"
              pagination
            />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div>
      <form-modal
       v-model="showForm"
       title="アフィニティレポートの登録"
       submit-button-text="登録"
       class="amc-affinity-modal"
       @click:submit="onClickSubmit"
      >
        <template #content>
          <ValidationForm ref="amcAffinityReportFormObserver">
            <AmcAffinityReportForm
              v-model:report-type="task.reportType"
              v-model:report-name="task.reportName"
              v-model:event="task.event"
              v-model:frequency="task.frequency"
              v-model:category="task.category"
              v-model:categories="task.categories"
              v-model:asin="task.asin"
              v-model:before-date="task.startDate"
              v-model:after-date="task.endDate"
              v-model:category1="task.category1"
              v-model:category2="task.category2"
              v-model:category3="task.category3"
              v-model:category4="task.category4"
              v-model:category5="task.category5"
              :min-date="minDate"
              :max-date="maxDate"
              :isEdit="isEdit"
              class="mb-10"
              ref="amcAffinityReportForm"
              @update:category="onChangeCategory"
            />
          </ValidationForm>
        </template>
      </form-modal>
    </div>
    <confirm-modal
      v-model="showConfirmModal"
      title="アフィニティレポート削除"
      @click:confirm="onClickDeleteConfirm"
      @click:cancel="showConfirmModal = false"
    >
      <template #content>
        <p class="p-4 whitespace-pre-wrap">レポート名 {{ `${deleteTarget.name}` }} を本当に削除しますか？</p>
      </template>
    </confirm-modal>

    <div class="mt-8">
      <div v-for="report in reports" class="mt-4">
        <vx-card>
          <div class="vx-row mx-1 mb-2">
            <div>{{ report.reportName }}</div>
            <div class="vx-row ml-auto">
              <div class="vx-col">
                <vs-button @click="onClickDownload(report.taskId, report.reportName)" class="px-4 pt-2 pb-1">
                  <VueFeather type="download" size="1.25rem" />
                </vs-button>
              </div>
            </div>
          </div>
          <data-table
            :column-defs="tableProp.reports.columnDefs"
            :default-col-def="tableProp.reports.defaultColDef"
            :row-data="report.data"
            :grid-options="tableProp.reports.gridOptions"
            pagination
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import DataTable from '@/components/table/DataTable';
import DataTableCellActions from '@/components/table/DataTableCellActions';
import FormModal from '@/components/modals/FormModal';
import ConfirmModal from '@/components/modals/ConfirmModal';
import AmcAffinityReportForm from '@/components/forms/AmcAffinityReportForm';
import AMC_REPORT_TYPE from '@/constants/AmcReportType';

export default {
  components: {
    DataTable,
    FormModal,
    ConfirmModal,
    AmcAffinityReportForm,
  },
  data() {
    return {
      openingPanel: [],
      // 表のプロパティ
      tableProp: {
        tasks: {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: true,
          },
          columnDefs: [
            {
              headerName: 'アクション',
              field: 'action',
              cellRenderer: 'dataTableCellActions',
              cellRendererParams: {
                editable: true,
                deletable: true,
                onClickEdit: this.onClickEdit,
                onClickTrash: this.onClickTrash,
              },
              width: 120,
            },
            {
              headerName: 'レポート名',
              field: 'reportName',
            },
            {
              headerName: '開始日',
              field: 'startDate',
              width: 150,
            },
            {
              headerName: '終了日',
              field: 'endDate',
              width: 150,
            },
            {
              headerName: 'ステータス',
              field: 'status',
              width: 150,
            },
            {
              headerName: 'エラー内容',
              field: 'statusReason',
            },
          ],
          gridOptions: {
            autoSizeStrategy: {
              type: 'fitCellContents'
            },
            components: {
              dataTableCellActions: DataTableCellActions,
            },
          },
        },
        reports: {
          defaultColDef: {
            sortable: true,
            editable: false,
            resizable: true,
            suppressMenu: true,
          },
          columnDefs: [
            {
              headerName: 'セグメント名',
              field: 'segmentName',
              width: 320,
            },
            {
              headerName: 'セグメントユーザー数',
              field: 'userCount',
            },
            {
              headerName: 'ターゲットユーザー数',
              field: 'allTargetUu',
            },
            {
              headerName: '出現率',
              field: 'overlap',
              width: 120,
              percent: true,
            },
            {
              headerName: 'セグメント総ユーザー数',
              field: 'allSegmentUu',
            },
            {
              headerName: 'Amazon総ユーザー数',
              field: 'allUu',
            },
            {
              headerName: 'アフィニティスコア',
              field: 'afinityScore',
              percent: true,
            },
          ],
          gridOptions: {},
        },
      },
      showConfirmModal: false,
      editId: -1, // 編集対象ID
      deleteTarget: { name: '', id: null },
      showForm: false,
      task: {
        reportType: null,
        reportName: null,
        event: [],
        frequency: null,
        category: null,
        categories: [],
        startDate: null,
        endDate: null,
        asin: null,
        category1: [],
        category2: [],
        category3: [],
        category4: [],
        category5: [],
      },
      minDate: null,
      maxDate: null,
    };
  },
  computed: {
    ...mapState('amcAffinityReports', ['reportTasks', 'reports', 'minStartDay']),
    ...mapState('account', ['activeAccount']),
    isEdit() {
      return this.editId !== -1;
    },
  },
  async mounted() {
    await Promise.all([
      this.listReportTasks(),
      this.listEcUserCategories(),
      this.fetchReports(),
      this.fetchCategories(),
      this.fetchMinStartDay(),
    ]);
    this.minDate = moment(this.minStartDay).toDate(); // amc_report_ad_campaignのMIN(cost_month)
    this.maxDate = moment().subtract(1, 'days').toDate(); // 昨日
  },
  methods: {
    ...mapActions('amcAffinityReports', [
      'listReportTasks',
      'listEcUserCategories',
      'fetchReports',
      'fetchCategories',
      'fetchMinStartDay',
      'downloadCSV',
      'updateReportTask',
      'deleteReportTask',
      'addReportTask',
    ]),
    async onClickAdd() {
      this.editId = -1;

      this.openingPanel = ['panel1'];
      await this.initialize();
      this.showForm = true;
    },
    async onClickEdit({ index }) {
      const target = structuredClone(this.reportTasks[index]);
      this.editId = target['id'];

      await this.initialize();
      this.task.reportType = {text: AMC_REPORT_TYPE[target.reportType] , value: target.reportType}
      this.task.reportName = target.reportName;
      this.task.startDate = target.startDate;
      this.task.endDate = target.endDate;
      if (target.params.hasOwnProperty('event')) {
        this.task.event = target.params.event;
      }
      if (target.params.hasOwnProperty('frequency')) {
        this.task.frequency = String(target.params.frequency);
      }
      if (target.params.hasOwnProperty('category')) {
        this.task.category = target.params.category;
      }
      if (target.params.hasOwnProperty('categories')) {
        this.task.categories = target.params.categories;
      }
      if (target.params.hasOwnProperty('asin')) {
        this.task.asin = target.params.asin.join('\n');
      }
      if (target.params.hasOwnProperty('category1')) {
        this.task.category1 = target.params.category1;
      }
      if (target.params.hasOwnProperty('category2')) {
        this.task.category2 = target.params.category2;
      }
      if (target.params.hasOwnProperty('category3')) {
        this.task.category3 = target.params.category3;
      }
      if (target.params.hasOwnProperty('category4')) {
        this.task.category4 = target.params.category4;
      }
      if (target.params.hasOwnProperty('category5')) {
        this.task.category5 = target.params.category5;
      }
      this.showForm = true;
    },
    async onClickTrash({ index }) {
      this.deleteTarget.name = this.reportTasks[index].reportName;
      this.deleteTarget.id = this.reportTasks[index].id;
      this.showConfirmModal = true;
    },
    async onClickDeleteConfirm() {
      try {
        await this.deleteReportTask({ taskId: this.deleteTarget.id });
        this.showConfirmModal = false;
        await this.listReportTasks();
        this.fetchReports()
      } catch (e) {
        console.log(e);
      }
    },
    async onClickSubmit() {
      try {
        const result = await this.$refs.amcAffinityReportFormObserver.validate();
        if (!result.valid) return;
        if (this.editId === -1) {
          await this.addReportTask({
            reportType: this.task.reportType.value,
            reportName: this.task.reportName,
            startDate: this.task.startDate,
            endDate: this.task.endDate,
            params: this.transformParams(),
          });
        } else {
          await this.updateReportTask({
            taskId: this.editId,
            reportName: this.task.reportName,
          });
        }
        this.showForm = false;
        window.setTimeout(async () => {
          await this.initialize();
        }, 200);
        await this.listReportTasks();
        this.fetchReports()
      } catch (e) {
        console.log(e);
      }
    },
    transformParams() {
      let params = {};
      if (this.task.event.length > 0) {
        params.event = this.task.event;
      }
      if (this.task.frequency) {
        params.frequency = Number(this.task.frequency);
      }
      if (this.task.asin) {
        const asin = this.task.asin.split('\n').filter((data) => data.length > 0);
        if (asin.length > 0) {
          params.asin = asin;
        }
      }
      if (this.task.category && this.task.categories.length > 0) {
        params.category = this.task.category;
        params.categories = this.task.categories;
      }
      if (Array.isArray(this.task.category1) && this.task.category1.length > 0) {
        params.category1 = this.task.category1;
      }
      if (Array.isArray(this.task.category2) && this.task.category2.length > 0) {
        params.category2 = this.task.category2;
      }
      if (Array.isArray(this.task.category3) && this.task.category3.length > 0) {
        params.category3 = this.task.category3;
      }
      if (Array.isArray(this.task.category4) && this.task.category4.length > 0) {
        params.category4 = this.task.category4;
      }
      if (Array.isArray(this.task.category5) && this.task.category5.length > 0) {
        params.category5 = this.task.category5;
      }
      return params;
    },
    async onClickDownload(taskId, reportName) {
      try {
        await this.downloadCSV({ taskId, reportName });
      } catch (e) {
        console.log(e);
      }
    },
    onChangeCategory() {
      this.task.categories = [];
    },
    async initialize() {
      this.task.reportType = null;
      this.task.reportName = null;
      this.task.event = [];
      this.task.frequency = null;
      this.task.category = null;
      this.task.categories = [];
      this.task.startDate = null;
      this.task.endDate = null;
      this.task.asin = null;
      this.task.category1 = [];
      this.task.category2 = [];
      this.task.category3 = [];
      this.task.category4 = [];
      this.task.category5 = [];
      await this.$refs.amcAffinityReportFormObserver.resetForm();
    },
  },
};
</script>

<style scoped>
.amc-affinity-modal :deep(.vs-popup--content):has(.no-category-selected) {
  overflow: visible !important;
}
</style>
